(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/company-details/components/company-details-form/components/addresses.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/company-details/components/company-details-form/components/addresses.js');
"use strict";


const {
  ADDRESS_TYPES
} = svs.ticket_partner.companyDetails.constants;
const {
  useContext,
  Fragment
} = React;
const {
  getAddressByType
} = svs.ticket_partner.companyDetails.utils;
const {
  Address
} = svs.ticket_partner.companyDetails.components.companyDetailsForm.components;
const Addresses = () => {
  const {
    state
  } = useContext(svs.ticket_partner.CompanyDetailsContext);
  const {
    addresses
  } = state.companyDetails;
  const {
    BILLING,
    VISITING,
    LEGAL
  } = ADDRESS_TYPES;
  return React.createElement(Fragment, null, React.createElement(Address, {
    adress: getAddressByType(addresses, VISITING)
  }), React.createElement(Address, {
    adress: getAddressByType(addresses, BILLING)
  }), React.createElement(Address, {
    adress: getAddressByType(addresses, LEGAL),
    disableOnEdit: true
  }));
};
svs.ticket_partner.companyDetails.components.companyDetailsForm.components.Addresses = Addresses;

 })(window);